import { CustomersDto } from '@/src/models/CustomersDto';
import { Media } from '@/src/models/MeidaDto';

export type RecyclingRequestStatus =
  | 'REQUEST'
  | 'PROCESSING'
  | 'SHIPPING'
  | 'CANCELED_BY_CUSTOMER'
  | 'CANCELED_BY_CARRIER'
  | 'CANCELED_BY_ADMIN'
  | 'COMPLETED'
  | 'PARTIAL_COMPLETE'
  | 'SHIPPING_DELAYED'
  | 'PROCESS_DELAYED';

export interface RecyclingRequestMedia {
  id: number;
  createdAt: string;
  updatedAt: string;
  media: Media;
}

export interface RecyclingRequestProduct {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  productName: string;
  optionName: string;
  count: number;
  weight: number;
  totalWeight: number;
  carbonEmissionReduction: number;
  totalCarbonEmissionReduction: number;
  pineScore: number;
}

export interface RecyclingRequestDetail {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  canceledAt: string;
  invoiceNo: string;
  orderDetailNo: string;
  reservationNo: string;
  status: string;
  cancelReason: string;
}

export class RecyclingRequestDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  canceledAt: string;
  reqNo: string;
  customerId: number;
  totalWeight: number;
  totalCarbonEmissionReduction: number;
  totalPineScore: number;
  status: RecyclingRequestStatus;
  description: string;
  requestMemo: string;
  requestAddress: string;
  requestAddressName: string;
  cancelReason: string;
  recyclingCouponId: number;
  requestName: string;
  requestPhone: string;
  boxCount: number;
  customer: CustomersDto;
  recyclingRequestMedias: RecyclingRequestMedia[];
  recyclingRequestProducts: RecyclingRequestProduct[];
  recyclingRequestDetails: RecyclingRequestDetail[];
  logisProvider: string;
  isAvailablePartialComplete: boolean;
}

export class RecyclingRefreshStatusDto {
  totalCnt: number;
  updateToCompleteCnt: number;
  updateToProcessCnt: number;
  updateToShippingCnt: number;
}
